import React from "react";
import { MapPin } from "lucide-react";
import { formatCoordinate } from "../../utils/tspCoordinates";

// A route stop's optional details under its name: where it is (latitude /
// longitude, e.g. picked on the map) and the areas planned there. Renders
// nothing for a stop without details. Used by Add Journey and Route Planning.
export default function TspRouteStopDetails({ latitude, longitude, areas }) {
  const hasPoint = Number.isFinite(latitude) && Number.isFinite(longitude);
  const hasAreas = Array.isArray(areas) && areas.length > 0;
  if (!hasPoint && !hasAreas) return null;
  return (
    <span className="tsp-route-stop-meta">
      {hasPoint && (
        <span>
          <MapPin size={11} aria-hidden="true" /> {formatCoordinate(latitude)}, {formatCoordinate(longitude)}
        </span>
      )}
      {hasAreas && <span>Areas: {areas.join(", ")}</span>}
    </span>
  );
}
